import React from 'react'

const SvgMedalOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M8 16.502v4.892c0 .917 1.13 1.35 1.743.669L12 19.555l2.257 2.508c.613.681 1.743.248 1.743-.669v-4.892a8.463 8.463 0 01-4 .998 8.462 8.462 0 01-4-.998z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.567 6.365c-.09-.243-.278-.365-.566-.365-.288 0-.484.12-.586.362l-.42 1.343H9.533c-.29.02-.461.152-.516.395-.056.244.035.47.271.678l1.083.831-.465 1.63c-.07.251-.009.46.18.626.19.166.438.179.742.04l1.174-.817 1.142.8c.265.155.508.147.729-.023.221-.17.286-.386.194-.646l-.469-1.61 1.117-.831c.24-.21.329-.436.267-.678-.062-.242-.24-.374-.53-.395h-1.474l-.41-1.34z'
    />
    <path fillRule='evenodd' clipRule='evenodd' d='M12 14a5 5 0 100-10 5 5 0 000 10zm7-5A7 7 0 115 9a7 7 0 0114 0z' />
  </svg>
)

export default SvgMedalOutline
